module.exports = __webpack_public_path__ + "bo.svg?607a7e950232d775102e79abc0076c93";